@if (tour.potentialAction) {
  <ng-container *ngxPermissionsOnly="['ROLE_USER']">
  @for (action of tour.potentialAction | availableActions; track action) {
    <button
      mat-button
      [attr.data-action]="action.name"
      (click)="executeWorkflowAction(action)"
      >
      @if (action.name == 'delete') {
        <mat-icon>delete</mat-icon>
        {{ 'core.deleteBtn' | translate }}
      } @else {
        @if (getTargetState(action.name); as targetState) {
          <mat-icon [svgIcon]="targetState.svgIcon">{{ targetState.matIcon }}</mat-icon>
        }
        {{ ('tourDetails.transitions.' + action.name) | translate }}
      }
    </button>
  }
  @if (undoTransitionAction) {
    <button
      mat-button
      [attr.data-action]="undoTransitionAction.name"
      (click)="executeWorkflowAction(undoTransitionAction)"
      >
      <mat-icon>undo</mat-icon>
      {{ 'tourDetails.transitions.undo' | translate }}
    </button>
  }
  </ng-container>
}

<a mat-button [routerLink]="['./', tour | objectId, 'edit']">
  <mat-icon>edit</mat-icon>
  {{ 'tours.actions.edit' | translate }}
</a>
<button mat-button type="button" (click)="print(tour)" [class.bubble]="!tour.printed">
  <mat-icon>print</mat-icon>
  {{ 'tours.actions.print' | translate }}
</button>
